/** @jsx jsx */
import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';

export const activePage = css({
  background: colorsPalette.teal,
  borderRadius: 20,
  '& a': {
    color: colorsPalette.white,
    '&:hover, &:visited': {
      color: colorsPalette.white,
    },
    '&:hover': {
      background: colorsPalette.teal,
    },
  },
});

export const arrowBtnCss = css({
  alignItems: 'center',
  backgroundColor: colorsPalette.transparent,
  border: `1px solid ${colorsPalette.grey20}`,
  borderRadius: 2,
  color: colorsPalette.black,
  cursor: 'pointer',
  display: 'flex',
  height: 52,
  justifyContent: 'center',
  textDecoration: 'none',
  width: 52,
  '&:hover, &:visited': {
    color: colorsPalette.black,
  },
});

export const arrowItemCss = css({
  width: 'auto',
  '& a:hover': {
    background: colorsPalette.transparent,
    borderRadius: 0,
  },
});

export const labelContainerCss = css({
  display: 'flex',
  alignItems: 'center',
});

export const leftArrowBtnCss = css({
  [MediaQueries.sm]: {
    marginRight: 10,
  },
});

export const leftArrowItemCss = css({
  marginRight: 14,
});

export const pageNumberCss = css({
  alignItems: 'center',
  color: colorsPalette.black,
  display: 'flex',
  fontWeight: fontWeights.medium,
  height: 36,
  justifyContent: 'center',
  textDecoration: 'none',
  width: 36,
  '&:hover, &:visited': {
    color: colorsPalette.black,
  },
  '&:hover': {
    background: colorsPalette.grey10,
    borderRadius: 20,
  },
});

export const pagesContainerCss = css({
  alignItems: 'center',
  display: 'flex',
  marginBottom: 27,
});

export const paginationContainerCss = css({
  display: 'flex',
  flexDirection: 'column',
});

export const paginationItemCss = css(typography.effra18, {
  marginRight: 12,
});

export const paginationLabelCss = css(typography.effra16, {
  color: colorsPalette.grey60,
});

export const rightArrowItemCss = css({
  marginLeft: 14,
  marginRight: 0,
});

export const rightArrowBtnCss = css({
  [MediaQueries.sm]: {
    marginLeft: 10,
  },
});
